import { Site } from '@envato/foundation-types'
import noIndexAllowList from './noIndexAllowList'
import defaultConfig from './defaults'

export default {
  name: 'ThemeForest',
  abbreviation: 'TF',
  domain: 'themeforest.net',
  google_analytics_id: 'UA-11834194-7',
  google_remarketing_label: 'u-J6CI3SqQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. responsive WordPress',
  show_category_in_selected_filters: true,
  categories_with_forced_search_page: [
    'ui-templates/figma',
    'ui-templates/adobe-xd'
  ],
  search_query: {
    default_sort_by_per_category: {
      'template-kits': 'random',
      'ui-templates/figma': 'random',
      'ui-templates/adobe-xd': 'random'
    }
  },
  noIndex: noIndexAllowList({
    site: Site.themeforest,
    routes: defaultConfig.noIndex.routes,
    params: defaultConfig.noIndex.params
  }),
  CSATFeedbackURL: 'https://www.getfeedback.com/r/wBD3H3yB'
}
